var site = site || {};

site.quickshop = site.quickshop || {};
(function ($) {
  Drupal.behaviors.hotspotProductGridFormatterV1 = {
    attached: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      var $template = $('.js-hotspot-product-grid-formatter-v1', context);
      var $hotspots = $('.js-hotspot-product-v1', $template);
      var productsArray = page_data['custom-mpp'].products || [];

      $hotspots.each(function () {
        var $hotspot = $(this);
        var $link = $('.js-hotspot', $hotspot);
        var $productId = $link.data('productId');
        var productData = _.find(productsArray, function (p) {
          return p.PRODUCT_ID === $productId;
        });

        $($link).attr('href', productData.url);
        $hotspot.find('.js-qs_link').once().on('click', function (e) {
          e.stopPropagation();
          e.preventDefault();
          site.quickshop(productData);
        });
      });
    }
  };
})(jQuery);
